const mutations = {
    COUPON_LOADING: state => {
        state.couponStatus = "loading";
    },
    COUPON_SUCCESS: (state, coupon) => {
        state.couponStatus = "success";
        // state.couponCart = coupon.data;
        state.couponApplied = true;
        Vue.set(state, "couponCart", coupon.data);
    },
    COUPON_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.couponStatus = "error";
        state.couponErrors.record(errors);
    },
    UPDATE_DISCOUNT_TOTAL: (state, payload) => {
        let discount = 0;
        let coupon = payload.coupon;
        let coupon_value = parseFloat(coupon.c_value);
        let total = parseFloat(payload.total);

        if (coupon.c_method == "fixed") {
            discount = coupon_value;
        }

        if (coupon.c_method == "percent") {
            discount = (total * coupon_value) / 100;
        }

        if (total <= discount) {
            discount = total;
        }

        // state.discountTotal = discount;
        Vue.set(state, "discountTotal", discount.toFixed(2));
    },
    COUPON_MESSAGE: (state, payload) => {
        let coupon_message = "";

        if (state.couponErrors.any()) {
            coupon_message = "";

            if (payload.akv) {
                coupon_message = coupon_message + "Active & Creative Kids or ";
            }

            coupon_message = coupon_message + LMP.appNameUrls.client + " voucher Invalid or Already used. Make sure you're logged in as the ";
            if (payload.akv) {
                coupon_message = coupon_message + "Active & Creative Kids / ";
            }
            coupon_message = coupon_message + LMP.appNameUrls.client + " voucher recipient.";

            // if(payload.akv && state.couponErrors.errors.error_voucher.startsWith("Technical")){
            //     coupon_message = state.couponErrors.errors.error_voucher;
            // }

        } else {
            if (state.couponApplied) {
                coupon_message = "Voucher applied successfully";
            }
        }

        // state.couponMessage = coupon_message;
        Vue.set(state, "couponMessage", coupon_message);
    },
    STORE_COUPON: state => {
        window.localStorage.setItem("couponStore", JSON.stringify(state.couponCart));
        window.localStorage.setItem("couponApplied", JSON.stringify(state.couponApplied));
    },
    REMOVE_VOUCHER: state => {
        state.couponStatus = "";
        // state.couponMessage = "";
        state.couponCart = {};
        state.couponApplied = false;
        state.discountTotal = 0;
        window.localStorage.removeItem("couponStore");
        window.localStorage.removeItem("couponApplied");
    },
    CLEAR_COUPON_ERRORS: state => {
        state.couponStatus = "";
        // state.couponMessage = "";
        state.couponErrors.clear();
    },
    CLEAR_COUPON_MESSAGE: state => {
        // state.couponMessage = "";
        Vue.set(state, "couponMessage", "");
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
